export const videoAllowedExtension = ['mp4'];

export const altAssetAllowedExtension = ['webm'];

export const imageUrl = '/assets/image/';

export const jsonAllowedExtension = ['json'];

export enum translationContentName {
  text = 'Text',
  images = 'Images',
  page_section_tabheaders = 'Pages/Section/Tab-Headers',
  resources = 'Resources'
}

export const fileDefaultName = {
  name: 'No Resource Title'
};

export const translationOptionsEnum = {
  text: { value: '1', key: 'Text' },
  images: { value: '2', key: 'Images' },
  page_section_tabheaders: { value: '3', key: 'Pages/Section/Tab-Headers' },
  resources: { value: '4', key: 'Resources' }
};

export enum resourceDataType {
  image,
  link,
  video
}
export const resourceAllowedExtension = [
  'jpg', 'jpeg', 'png', 'pdf', 'xlsx', 'docx', 'pptx', 'ppt', 'doc', 'xls', 'msg', 'zip', 'oft'
];

export enum TranslationSortBy {
  lastCreated = 1,
  lastEdited = 2
}
